import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import SavedScriptCard from './SavedScriptCard';

const ScriptLibrary = ({ scripts, onViewScript, onEditScript, onDeleteScript }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filterType, setFilterType] = useState('all');
  const [filterIndustry, setFilterIndustry] = useState('all');

  const typeOptions = [
    { value: 'all', label: 'All Types' },
    { value: 'sms', label: 'SMS' },
    { value: 'email', label: 'Email' },
    { value: 'call', label: 'Call Scripts' }
  ];

  const industryOptions = [
    { value: 'all', label: 'All Industries' },
    { value: 'real-estate', label: 'Real Estate' },
    { value: 'insurance', label: 'Insurance' },
    { value: 'saas', label: 'SaaS/Technology' },
    { value: 'automotive', label: 'Automotive' },
    { value: 'financial', label: 'Financial Services' }
  ];

  const filteredScripts = scripts?.filter((script) => {
    const matchesSearch = script?.title?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
                         script?.situation?.toLowerCase()?.includes(searchQuery?.toLowerCase());
    const matchesType = filterType === 'all' || script?.type === filterType;
    const matchesIndustry = filterIndustry === 'all' || script?.industry === filterIndustry;
    
    return matchesSearch && matchesType && matchesIndustry;
  });

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between gap-4">
        <h2 className="text-xl font-semibold text-foreground flex items-center gap-2">
          <Icon name="BookOpen" size={24} color="var(--color-primary)" />
          Your Script Library
        </h2>
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="FileText" size={16} />
          <span>{filteredScripts?.length} scripts</span>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="md:col-span-3">
          <Input
            type="search"
            placeholder="Search scripts by title or situation..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e?.target?.value)}
          />
        </div>
        <Select
          label="Filter by Type"
          options={typeOptions}
          value={filterType}
          onChange={setFilterType}
        />
        <Select
          label="Filter by Industry"
          options={industryOptions}
          value={filterIndustry}
          onChange={setFilterIndustry}
        />
      </div>
      {filteredScripts?.length === 0 ? (
        <div className="text-center py-12">
          <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mx-auto mb-4">
            <Icon name="Search" size={32} color="var(--color-muted-foreground)" />
          </div>
          <h3 className="text-lg font-semibold text-foreground mb-2">No scripts found</h3>
          <p className="text-sm text-muted-foreground">
            {searchQuery || filterType !== 'all' || filterIndustry !== 'all' ?'Try adjusting your filters' :'Generate your first script to get started'}
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {filteredScripts?.map((script) => (
            <SavedScriptCard
              key={script?.id}
              script={script}
              onView={onViewScript}
              onEdit={onEditScript}
              onDelete={onDeleteScript}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ScriptLibrary;